import React from 'react'
import { Outlet } from 'react-router-dom'

function HelpHome() {
    return (
        <>
            <Outlet />
        </>
    )
}

export default HelpHome